import React, { createContext, useContext } from 'react'

const TransitionStatusContext = createContext('entered')

export const useTransitionStatus = () => useContext(TransitionStatusContext)

export const TransitionStatusProvider = ({ status, children }) => (
  <TransitionStatusContext.Provider value={status}>
    {children}
  </TransitionStatusContext.Provider>
)
